import { useTLang } from 'intl/intl';

export function useStoresSchedulesPageLang({ supportPhone }: Props) {
  return {
    page: {
      regular: {
        title: useTLang({ id: 'storesSchedulePage.regularSchedule' }),
        description: useTLang({
          id: 'storesSchedulePage.regularScheduleDescription',
        }),
        info: useTLang(
          { id: 'storesSchedulePage.regularScheduleAlert' },
          { phone: supportPhone },
        ),
      },
      holiday: {
        title: useTLang({ id: 'storesSchedulePage.holidays' }),
        description: useTLang({
          id: 'storesSchedulePage.holidaysScheduleDescription',
        }),
        info: useTLang({
          id: 'storesSchedulePage.holidayScheduleAlert',
        }),
      },
      specialDay: {
        title: useTLang({ id: 'storesSchedulePage.specialDay' }),
        description: useTLang({
          id: 'storesSchedulePage.specialDayScheduleDescription',
        }),
        info: useTLang({
          id: 'storesSchedulePage.specialDayScheduleAlert',
        }),
      },
    },
  };
}

interface Props {
  supportPhone: string;
}
